import axios from "@/gateway/backendapi";
// import stopProgressBar from "../../services/progressbar/progress"

const getDonationSummary = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/Financials/Contributions/Transactions/Summary")
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        /*eslint no-undef: "warn"*/
        NProgress.done();
        if (error.response) {
          reject(error.response);
        } else {
          reject(error);
        }
      });
  });
};
const getDonationSummaryPerPerson = async (id, startDate, endDate) => {
  if (!startDate) {
    startDate = "";
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/Financials/Contributions/Transactions/Summary/${id}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          /*eslint no-undef: "warn"*/
          NProgress.done();
          if (error.response) {
            reject(error.response);
          } else {
            reject(error);
          }
        });
    });
  } else {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/Financials/Contributions/Transactions/Summary/${id}?startDate=${startDate}&endDate=${endDate}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          /*eslint no-undef: "warn"*/
          NProgress.done();
          if (error.response) {
            reject(error.response);
          } else {
            reject(error);
          }
        });
    });
  }
};
const getContributionList = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/Financials/Contributions/Transactions?page=1")
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        /*eslint no-undef: "warn"*/
        NProgress.done();
        if (error.response) {
          reject(error.response);
        } else {
          reject(error);
        }
      });
  });
};
const getContributionItem = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/financials/contributions/items")
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        /*eslint no-undef: "warn"*/
        NProgress.done();
        if (error.response) {
          reject(error.response);
        } else {
          reject(error);
        }
      });
  });
};

const getBanks = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/Financials/GetBanks")
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        /*eslint no-undef: "warn"*/
        NProgress.done();
        if (error.response) {
          reject(error.response);
        } else {
          reject(error);
        }
      });
  });
};
export default {
  getContributionList,
  getContributionItem,
  getBanks,
  getDonationSummary,
  getDonationSummaryPerPerson,
};
